import {NgModule} from '@angular/core';
import {FileItemsComponent} from './item';
import {IonicModule} from '@ionic/angular';
import {NgClass, NgForOf, NgIf, NgStyle} from '@angular/common';
import {IconComponentModule} from '../icon/item.module';
import {GalleryModalComponentModule} from '../../shared/galleryModal/item.module';
import {ButtonComponentModule} from '../button/item.module';
import {BlockElementLabelComponentModule} from 'app/components/blocks/components/blockElementLabel/item.module';

@NgModule({
    imports: [
        IonicModule,
        NgStyle,
        NgClass,
        NgIf,
        IconComponentModule,
        NgForOf,
        GalleryModalComponentModule,
        ButtonComponentModule,
        BlockElementLabelComponentModule,
    ],
  exports: [
    FileItemsComponent
  ],
  declarations: [FileItemsComponent],
  providers: [],
})
export class FileItemsComponentModule {
}
